import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import * as _ from 'lodash';

import { PaymentService as PaymentLocalService } from '../../../services/payment/payment.service';

@Component({
  selector: 'app-plan',
  templateUrl: './plan.component.html',
  styleUrls: ['./plan.component.scss']
})
export class PlanComponent implements OnInit {
  packageId: any;
  isCameraPlanEnabled = false;
  plansData: any;
  taxPercentage = 0;

  subscriptionPlan: any;
  cameraPlan: any;

  loader = true;
  constructor(private router: Router, public paymentLocalService: PaymentLocalService) {
    this.paymentLocalService.planDataSubscription.subscribe(response => {
      if (response) {
        this.plansData = response;
        this.subscriptionPlan  = _.find(this.plansData, {plan_type: 'subscription' }) ? _.find(this.plansData, {plan_type: 'subscription' }) : false;
        if (this.subscriptionPlan && this.subscriptionPlan.tax) {
          this.taxPercentage = this.subscriptionPlan.tax;
        }
        this.cameraPlan  = _.find(this.plansData, {plan_type: 'camera' });
        this.loader = false;
      }
    });
  }

  ngOnInit() {
    this.isCameraPlanEnabled = this.paymentLocalService.getCameraPlan() ? true : false;
  }

  submitPlanSteps() {
    this.paymentLocalService.setPackageId(this.packageId);
    if (this.isCameraPlanEnabled) {
      this.paymentLocalService.setCameraPlan('1001');
    } else {
      this.paymentLocalService.setCameraPlan(undefined);
    }
    this.paymentLocalService.submitPlanSteps();
    this.router.navigate(['/payment/card']);
  }

}
